import { defaults as _defaults } from 'lodash';
var PaymentPartner;
(function (PaymentPartner) {
    PaymentPartner["Convera"] = "Convera";
    PaymentPartner["PayrollExperts"] = "PayrollExperts";
    PaymentPartner["Wise"] = "Wise";
    PaymentPartner["Forte"] = "Forte";
})(PaymentPartner || (PaymentPartner = {}));
var AccountType;
(function (AccountType) {
    AccountType["Checking"] = "Checking";
    AccountType["Savings"] = "Savings";
})(AccountType || (AccountType = {}));
var FundingInterval;
(function (FundingInterval) {
    FundingInterval["NinetySixHours"] = "NinetySixHours";
    FundingInterval["FortyEightHours"] = "FortyEightHours";
})(FundingInterval || (FundingInterval = {}));
const defaultEmpACHAccount = {
    PK: 0,
    PaymentPartner: PaymentPartner.Wise,
    CustomerAccountType: AccountType.Checking,
    FundingInterval: FundingInterval.NinetySixHours,
    ClientName: '',
    FederalID: '',
    RoutingNumber: '',
    AccountNumber: '',
    CID: '',
    CustomerBankID: '',
    CustomerBankAccount: '',
    CustomerName: '',
    CustomerAddress: '',
    CustomerCity: '',
    CustomerStateProvinceFK: '',
    CustomerPostalCode: '',
    CustomerPhone: ''
};
class EmpACHAccount {
    PK;
    PaymentPartner;
    CustomerAccountType;
    CompanyID;
    FundingInterval;
    RoutingNumber;
    AccountNumber;
    ClientName;
    ClientNumber;
    FederalID;
    Inactive;
    CID;
    CustomerBankID;
    CustomerBankAccount;
    CustomerName;
    CustomerAddress;
    CustomerCity;
    CustomerStateProvinceFK;
    CustomerPostalCode;
    CustomerPhone;
    constructor(params) {
        _defaults(this, params, defaultEmpACHAccount);
    }
}
export { EmpACHAccount, FundingInterval, AccountType, PaymentPartner, defaultEmpACHAccount };
